(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('AnswerDetailController', AnswerDetailController);

    AnswerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Answer', 'SpecificQuestion', 'CustomUser', 'Comment', 'Task'];

    function AnswerDetailController($scope, $rootScope, $stateParams, previousState, entity, Answer, SpecificQuestion, CustomUser, Comment, Task) {
        var vm = this;

        vm.answer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:answerUpdate', function(event, result) {
            vm.answer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
